// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2wjVY","description":"PatientConsentPreview_description__1B6Tg"};